import * as React from "react";
import {
  Datagrid,
  List,
  TextField,
  EditButton,
  Edit,
  SimpleForm,
  TextInput,
  required,
  ListButton,
  TopToolbar,
  usePermissions,
  Pagination,
} from "react-admin";

const ProjectPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]} {...props} />
);

export const ErrorLinkList = () => {
  const { permissions } = usePermissions();
  return (
    <List perPage={1000} pagination={<ProjectPagination />}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="address" />
        {permissions.access === "super" || permissions.access === "admin" ? (
          <EditButton />
        ) : null}
      </Datagrid>
    </List>
  );
};

const ProjectEditActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="< Zurück" />
  </TopToolbar>
);

export const ErrorLinkEdit = (props) => (
  <Edit title="Edit Link" actions={<ProjectEditActions />}>
    <SimpleForm>
      <TextInput readOnly source="id" />
      <TextInput label="Link" source="address" validate={required()} />
    </SimpleForm>
  </Edit>
);
